<template>
  <div>
    <a
      v-for="(banner, index) in langBanners" :href="banner.siteLink" target="_blank"
      :key="index"
      class="banner-container and-some-temp-cache"
    >
      <img
        v-if="banner.image"
        :src="banner.image"
      />
    </a>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'Banners',

  computed: {
    ...mapFields(Object.keys(state)),

    langBanners () {
      if (this.lang) {
        return this.bannersByLang[this.lang]
      }
      return []
    },
  },
}
</script>

<style>
.banner-container {
  margin: 2px 0 0 0;
  padding: 0px;
  float: left;
}
</style>
